

/*
 * Copyright (c) 2021.
 * Simon
 */

export const REPLY_SEGMENT_INDEX_REQUEST = 'REPLY_SEGMENT_INDEX_REQUEST';
export const REPLY_SEGMENT_INDEX_SUCCESS = 'REPLY_SEGMENT_INDEX_SUCCESS';
export const REPLY_SEGMENT_INDEX_FAILURE = 'REPLY_SEGMENT_INDEX_FAILURE';

